import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import {
  addCallForActionError,
  addCallForActionSuccess,
  editCallForActionError,
  editCallForActionSuccess,
  getCallForActionError,
  getCallForActionSuccess,
} from './actions'
import {
  ADD_CALL_FOR_ACTION_ASYNC,
  EDIT_CALL_FOR_ACTION_ASYNC,
  GET_CALL_FOR_ACTION_ASYNC,
} from './constants'

const getCallForActionBody = (state, action) => ({
  name: state.awarenessCenter.callForActionForm.callForAction.name,
  page_title: state.awarenessCenter.callForActionForm.callForAction.title,
  is_public: state.awarenessCenter.callForActionForm.callForAction.isPublic,
  content: state.awarenessCenter.callForActionForm.callForAction.content,
  force_save: action.payload.forceSave || false,
})

const editCallForActionEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(EDIT_CALL_FOR_ACTION_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .editCallForAction(
          action.payload.id,
          getCallForActionBody(state$.value, action),
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          map((response) => editCallForActionSuccess(response)),
          catchError((error) => of(epicsErrorHandler(editCallForActionError, error, [400]))),
          takeUntil(action$.pipe(ofType(EDIT_CALL_FOR_ACTION_ASYNC.CANCEL)))
        )
    )
  )

const addCallForActionEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(ADD_CALL_FOR_ACTION_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .addCallForAction(
          getCallForActionBody(state$.value, action),
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          map(() => addCallForActionSuccess()),
          catchError((error) => of(epicsErrorHandler(addCallForActionError, error, [400]))),
          takeUntil(action$.pipe(ofType(ADD_CALL_FOR_ACTION_ASYNC.CANCEL)))
        )
    )
  )

const getCallForActionEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(GET_CALL_FOR_ACTION_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .getCallForAction(
          action.payload.id,
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          map((response) => getCallForActionSuccess(response)),
          catchError((error) => of(epicsErrorHandler(getCallForActionError, error))),
          takeUntil(action$.pipe(ofType(GET_CALL_FOR_ACTION_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(getCallForActionEpic, addCallForActionEpic, editCallForActionEpic)
